import * as ResourceApi from "../api/resources";
import {isNoU} from "../utils/DBUtils";

let config = {
    [ResourceApi.Types.Article]: {
        articleContentsOrder: 'contents'
    },
    [ResourceApi.Types.Break]: {
        breakStepsOrder: 'steps'
    },
    [ResourceApi.Types.Checklist]: {
        checklistItemGroupsOrder: 'itemGroups',
        checklistResultsOrder: 'results'
    },
    [ResourceApi.Types.DefaultUGCCampaign]: {
        ugcOverlayImagesOrder: 'overlayImages'
    },
    [ResourceApi.Types.Filtering]: {
      filteringDropdownsOrder: 'dropdowns',
      filteringResultsOrder: 'results'
    },
    [ResourceApi.Types.FilteringDropdown]: {
      filteringDropdownItemsOrder: 'items'
    },
    [ResourceApi.Types.FilteringResult]: {
      filteringResultContentOrder: 'contents'
    },
    [ResourceApi.Types.LeadGen]: {
        leadGenConfirmationsOrder: 'confirmations',
        leadGenFieldsOrder: 'fields'
    },
    [ResourceApi.Types.Listicle]: {
        listicleItemsOrder: 'items'
    },
    [ResourceApi.Types.ListicleItem]: {
        listicleItemContentsOrder: 'contents'
    },
    [ResourceApi.Types.PersonalityQuiz]: {
        personalityQuizQuestionsOrder: 'questions',
        personalityQuizResultsOrder: 'results'
    },
    [ResourceApi.Types.PersonalityQuizQuestion]: {
        personalityQuizAnswersOrder: 'answers'
    },
    [ResourceApi.Types.Poll]: {
        questionsOrder: 'questions'
    },
    [ResourceApi.Types.PollQuestion]: {
        answersOrder: 'answers'
    },
    [ResourceApi.Types.SpotTheDifferenceGame]: {
        spotTheDifferenceGameInstructionsOrder: 'instructions',
        spotTheDifferenceGameLevelsOrder: 'levels'
    },
    [ResourceApi.Types.TextTrivia]: {
        questionsOrder: 'questions',
        textTriviaResultsOrder: 'results'
    },
    [ResourceApi.Types.TextTriviaQuestion]: {
        answersOrder: 'answers'
    },
    [ResourceApi.Types.ReceiptVerificationCampaign]: {
        instructionsOrder: 'instructions',
        detailedInstructionsOrder: 'detailedInstructions'
    },
    [ResourceApi.Types.ReferralLinks]: {
        referralLinksOrder: 'referralLinks'
    },
    [ResourceApi.Types.UgcCampaign]: {
        instructionsOrder: 'instructions',
        ugcOverlayImagesOrder: 'overlayImages'
    },
    [ResourceApi.Types.DefaultUGCCampaign]: {
        instructionsOrder: 'instructions',
        ugcOverlayImagesOrder: 'overlayImages'
    }
};

// Apply shared config for all step types
for (let step of ResourceApi.AvailableSteps) {
    let existing = config[step];
    if (isNoU(existing)) {
        existing = {};
    }
    existing.breakStepRelatedBreaksOrder = 'relatedBreaks';
    config[step] = existing;
}

export default config;



// WEBPACK FOOTER //
// ./public/resources/reorderSaveConfig.js